import { ResourceTutorial } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getTutorials = async (): Promise<ResourceTutorial[]> => {
  const { data } = await queryBuilder('GET', 'resources/tutorials');
  return data;
};
